module.exports = __webpack_public_path__ + "static/media/screenshot-3.13f9bbcf.png";